var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-form-checkbox',{attrs:{"checked":_vm.value,"switch":"","size":"lg"},on:{"change":function($event){return _vm.emitUpdate($event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }